// extracted by mini-css-extract-plugin
export default {"ArrowBtn":"arrowBtn_ArrowBtn__pQn3A","Up":"arrowBtn_Up__3O+Sb","Down":"arrowBtn_Down__556mJ","Left":"arrowBtn_Left__2ZqLE","Right":"arrowBtn_Right__je3Op"};